import type { NostrEvent } from "nostr-tools";
import {
  catchError,
  defer,
  EMPTY,
  exhaustMap,
  filter,
  tap,
  type Observable,
  type OperatorFunction,
} from "rxjs";

/** One backward page per manual trigger; v7 timeline loaders use time windows. */
export function loadBackwardPage(
  request: (until: number | undefined) => Observable<NostrEvent>,
  onError: (error: unknown) => void,
): OperatorFunction<{ until?: number }, NostrEvent> {
  return (windows) =>
    defer(() => {
      let cursor: number | undefined;
      let exhausted = false;
      return windows.pipe(
        exhaustMap((window) => {
          if (exhausted) return EMPTY;
          const until = cursor ?? window.until;
          let oldest: number | undefined;
          return request(until).pipe(
            filter((event) => until === undefined || event.created_at <= until),
            tap({
              next: (event) => {
                oldest =
                  oldest === undefined
                    ? event.created_at
                    : Math.min(oldest, event.created_at);
              },
              complete: () => {
                if (oldest === undefined) exhausted = true;
                else cursor = oldest - 1;
              },
            }),
            // A failed page does not advance its cursor or kill future triggers.
            catchError((error: unknown) => {
              onError(error);
              return EMPTY;
            }),
          );
        }),
      );
    });
}
